import React from 'react';

import Layout from '../../../Layout';
import {
  infinityChecklist,
  maxChecklist
} from '../../../Widgets/SetPlan/ChecklistsAndContent/checklistContent';
import BackButton from '../../../../components/UI/BackButton';
import { Plan } from '..';
import PlanCard from './PlanCard';

import css from './AdditionalPlansScreen.module.scss';
import fccCss from '../FCC.module.scss';
import layoutCss from '../../../Layout/Layout.module.scss';
import { useToggles } from '../../../../state/toggles';
import { priceDeltas, savingsRewards } from '../../../../utils/prices';

interface AdditionalPlansScreenProps {
  onPlanSelect: (plan: Plan) => void;
  onInfoClick: (plan: Plan) => void;
  onBackClick: () => void;
}

const AdditionalPlansScreen = (props: AdditionalPlansScreenProps) => {
  const toggles = useToggles();
  const savings = savingsRewards(toggles);
  const deltas = priceDeltas(toggles);

  return (
    <Layout>
      <BackButton onClick={props.onBackClick} />
      <div className={layoutCss.layoutWrapper}>
        <h1>Get more from Greenlight</h1>
        <p>
          Greenlight kids earn even more when you upgrade. All plans cover the
          whole family, up to 5 kids.
        </p>
        <div className={css.bold}>
          Get access to the Family Cash Card, all core tools, plus:
        </div>
        <PlanCard
          header={
            <>
              Greenlight Infinity<sup>†</sup>
            </>
          }
          subheading={`Only ${deltas.infinity}/month`}
          showInfoIcon={true}
          features={infinityChecklist(() => props.onInfoClick('infinity'))}
          plan="infinity"
          onSelectPlan={() => props.onPlanSelect('infinity')}
          onInfoClicked={() => props.onInfoClick('infinity')}
          buttonText="Select Greenlight Infinity"
        />
        <PlanCard
          header="Greenlight Max"
          subheading={`Only $${deltas.max}/month`}
          showInfoIcon={true}
          features={maxChecklist(savings)}
          plan="max"
          onSelectPlan={() => props.onPlanSelect('max')}
          onInfoClicked={() => props.onInfoClick('max')}
          buttonText="Select Greenlight Max"
        />
        <div className={fccCss.textButton} onClick={() => props.onBackClick()}>
          No thanks, I don&apos;t need the perks.
        </div>
        <div className={fccCss.footer}>
          <p>
            <sup>†</sup>Requires mobile data or a WiFi connection, and access to
            sensory and motion data from cell phone to utilize family location
            sharing, SOS alerts and crash detection features. Messaging and data
            rates and other terms may apply.
          </p>
          <p>
            <sup>*</sup>See Greenlight&apos;s Terms of Service for details on
            earnings limits and how to qualify. Subject to change at any time.
          </p>
          <p>
            <sup>**</sup>Cell phone and purchase protection provided by Virginia
            Surety Company Inc. Cell phone protection is not available to
            residents of New York.
          </p>
          <p>
            By choosing to upgrade, you are accepting Greenlight&apos;s Terms of
            Service & Privacy Statement.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AdditionalPlansScreen;
